import {Component, Input, OnChanges} from '@angular/core';
import {ALL_COMP_CATEGORIES, ComponentCategory, HIDDEN_COMP_CATEGORIES} from '@twpub/core/enums';
import {ClientConfiguration, ComponentConfiguration} from '@twpub/core/utils';
import {ComponentDeclarationService} from '@twpub/core/services';
import {ConfigurableComponent} from '@twpub/core/models';

import {ComponentEditorComponent} from '../compeditor/component-editor/component-editor.component';

@Component({
  selector: 'pub-component-editors-list',
  templateUrl: './component-editors-list.component.html',
  styleUrls: ['./component-editors-list.component.scss'],
  standalone: true,
  imports: [ComponentEditorComponent]
})
export class ComponentEditorsListComponent implements OnChanges {
  @Input() configuration!: ClientConfiguration;

  compCategories = ALL_COMP_CATEGORIES;
  configMap: Record<ComponentCategory, ComponentConfiguration<ConfigurableComponent> | undefined> = {} as Record<ComponentCategory, ComponentConfiguration<ConfigurableComponent> | undefined>;

  constructor(private componentDeclarationService: ComponentDeclarationService) {
  }

  ngOnChanges(): void {
    this.prepareConfigMap();
  }

  private prepareConfigMap(): void {
    this.configMap = this.compCategories
      .filter(cat => HIDDEN_COMP_CATEGORIES.indexOf(cat) === -1)
      .reduce((map, compCategory) => {
        const scheme = this.configuration.scheme;
        map[compCategory] =
          this.configuration.getConfigurationSafe(compCategory) ||
          this.componentDeclarationService.createComponentConfigurationForCategory(compCategory, scheme);
        return map;
      }, {} as Record<ComponentCategory, ComponentConfiguration<ConfigurableComponent> | undefined>);
  }
}
